import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import RevenueChart from '../../Model/Individual/StatisticsModel/RevenueChart';

import IntroMarkdown from './IntroMarkdown';

export default function RevenueChartRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const { t } = useLanguage();
  const { intro, thisYear, thisYearMaxPrice } = data;

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <LegendWrapper>
        <LegendItem>
          <LegendBar backgroundColor={theme.primary} />
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>
            {t('statistics.revenue.thisYearSales')}
          </Text>
        </LegendItem>
        <LegendItem>
          <LegendDashedBar $color={theme.subText} />
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>
            {t('statistics.revenue.lastYearSales')}
          </Text>
        </LegendItem>
      </LegendWrapper>
      <ChartContainer>
        <RevenueChart
          thisYear={thisYear}
          thisYearMaxPrice={thisYearMaxPrice} />
      </ChartContainer>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const LegendWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const LegendItem = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const LegendBar = styled.div`
  width: 40px;
  height: 7px;

  border-radius: 2px;
  background-color: ${props => props.backgroundColor};
`;

const LegendDashedBar = styled.div`
  width: 40px;
  height: 0px;

  border-top: 2px dashed ${props => props.$color};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  overflow-x: auto;
`;
